import { useState } from "react";
import { useFavorites } from "@/hooks/useFavorites";

export default function FavoriteButton({ movieId }: { movieId: string }) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const [toast, setToast] = useState("");

  const active = isFavorite(movieId);

  const handleClick = () => {
    const nowActive = toggleFavorite(movieId);
    setToast(nowActive ? "已加入收藏" : "已取消收藏");
    window.setTimeout(() => setToast(""), 2000);
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        aria-pressed={active}
        className={`flex items-center gap-2 rounded-md px-5 py-2.5 text-sm font-medium transition-colors whitespace-nowrap ${
          active
            ? "bg-accent-500 text-foreground-950 hover:bg-accent-600"
            : "border border-background-300 bg-background-50 text-foreground-800 hover:border-primary-300 hover:text-primary-600"
        }`}
      >
        <i
          className={active ? "ri-heart-3-fill" : "ri-heart-3-line"}
          aria-hidden="true"
        ></i>
        {active ? "已收藏" : "收藏"}
      </button>

      {toast && (
        <div className="fixed bottom-24 left-1/2 z-[60] flex -translate-x-1/2 items-center gap-2 rounded-full bg-foreground-950/90 px-4 py-2 text-sm text-background-50 md:bottom-10">
          <i className="ri-checkbox-circle-line text-accent-400" aria-hidden="true"></i>
          {toast}
        </div>
      )}
    </>
  );
}